import React, { Component } from 'react';

import moment from 'moment-timezone';

import { DatePicker } from '@atlaskit/datetime-picker';

import { TestCycle } from '@qality/common-model';
import { DateFormatService } from '@qality/common-service';

import './_test-cycle-details-tab.scss';

type Props = {
  testCycle: TestCycle;
  handleDueDateChange: (value: string) => Promise<void>;
  canEdit: boolean;
};

type State = {
  showSelect: boolean;
};

export default class TestCycleDetailsTabDueDate extends Component<
  Props,
  State
> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showSelect: false,
    };
  }

  // eslint-disable-next-line complexity
  render(): JSX.Element {
    const testCycle = this.props.testCycle;
    return (
      <div className='test-cycle-details-page-due-date'>
        <span className='qality-label'>Due date:</span>
        {this.state.showSelect ? (
          <div className='test-cycle-details-date-picker-container hide-focus-wrapper'>
            <DatePicker
              id='datepicker-2'
              placeholder='DD/MM/YYYY'
              locale='en-GB'
              defaultValue={testCycle.dueDate ? testCycle.dueDate : undefined}
              autoFocus
              onBlur={() => {
                this.setState({ showSelect: false });
              }}
              onChange={(value) => {
                this.props.handleDueDateChange(value);
                this.setState({ showSelect: false });
              }}
            />
          </div>
        ) : (
          <span
            className={
              'test-cycle-date-label' +
              (this.props.canEdit ? ' test-cycle-editable-date-label' : '')
            }
            onClick={() => {
              if (this.props.canEdit) {
                this.setState({ showSelect: true });
              }
            }}
          >
            {testCycle.dueDate
              ? moment(testCycle.dueDate).format(
                  DateFormatService.longDateFormat
                )
              : ' No date '}
          </span>
        )}
      </div>
    );
  }
}
